import { Card, InfinityLoading, Pin2LineIcon } from 'ui';
import { useFeedInfiniteQuery } from '../queries';
import { PinnedContentObjectCard } from './pinned-content-object-card';

type P = {
  communityId?: string;
};

const PinnedFeed = ({ communityId }: P) => {
  const { data, fetchNextPage, hasNextPage, isFetching } = useFeedInfiniteQuery({
    communityId,
    pagination: { pageSize: 3 },
    pinned: true,
  });

  const items = data?.pages.flat() ?? [];

  if (items.length === 0) {
    return null;
  }

  return (
    <Card marginBottom={false} title={<Card.Title icon={<Pin2LineIcon />}>Pinned posts</Card.Title>}>
      <div className="pinned-feed__scroll">
        {items.map((item) => {
          if (item.type === 'event') {
            console.warn('[App] Trying to render object of `event` type in pinned feed.');
            return null;
          }

          return <PinnedContentObjectCard item={item} key={item.id} />;
        })}
        <div className="pinned-feed__loading">
          <InfinityLoading hasMoreData={hasNextPage} isLoading={isFetching} onEnter={fetchNextPage} />
        </div>
      </div>
    </Card>
  );
};

export default PinnedFeed;
